import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getOutboundTrunks } from 'services/api/AccessManagerAPI';

export const useGetOutboundTrunks = (isEnabled = false) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.outboundTrunks,
        queryFn: () => getOutboundTrunks(),
        enabled: isEnabled,
    });

    return {
        outboundTrunks: data,
        isOutboundTrunksLoading: isLoading,
        ...rest,
    };
};
